<mat-toolbar color="primary" style="font-size: 1.2em">
  <span>Property Binding</span>
  <span class="spacer"></span>
</mat-toolbar>

<div class="example-container mat-elevation-z8">
  <mat-table #table [dataSource]="dataSource" matSort class="mat-cell">
    @for (col of displayColumnsWithCatchIndex; track col) { @if (col.name !== 'actions') {
    <ng-container [matColumnDef]="col.name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ col.header }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        @switch (col.type) { @case ('text') {
        <div>{{ row[col.name] }}</div>
        } @case ('dropdown') {
        <div>{{ row[col.name]['name'] }}</div>
        } @case ('color') {
        <div>
          <label style="width: 50px; height: 20px" [style.background-color]="row[col.name]"> </label>
        </div>
        } }
      </mat-cell>
    </ng-container>
    } }

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef>
        <button mat-icon-button color="primary" (click)="addRecord()" [disabled]="!isNewRecordAddAvailalbe" *ngIf="!isReadOnly()">
          <mat-icon aria-label="Add new record">add</mat-icon>
        </button>
      </mat-header-cell>

      <mat-cell *matCellDef="let row">
        <button mat-icon-button color="accent" (click)="editRecord(row)" *ngIf="!isReadOnly()">
          <mat-icon aria-label="Edit">edit</mat-icon>
        </button>

        <button mat-icon-button color="accent" (click)="deleteRecord(row)" *ngIf="!isReadOnly()">
          <mat-icon aria-label="Delete">delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayColumnsWithOutCatchIndex"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayColumnsWithOutCatchIndex"></mat-row>
  </mat-table>

  @if (dataSource?.renderedData?.length === 0) {
  <div class="no-results">No results</div>
  }

  <mat-paginator></mat-paginator>
</div>
